import { Component } from '@angular/core';
import { NavParams, ModalController } from 'ionic-angular';

import { OrcamentoService } from '../../../../providers/orcamento-service';
import { MenuService } from '../../../../providers/menu-service';

import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';
import { AlertService } from '../../../../providers/alert-service';

import { ModalNaoSeAplicaPage } from "../../../modais/nao-se-aplica/modal-nao-se-aplica";
import { ModalPreVisualizarOrcamentoPage } from '../../../modais/modal-pre-visualizacao/orcamento/modal-pv-orcamento';

@Component({
    selector: 'page-resumo-acoes',
    templateUrl: 'resumo-acoes.html',
    providers: [
        OrcamentoService
    ]
})
export class OrcamentoResumoAnalisePage extends ModulosController {
    listaAnalises: any[];
    loading: boolean = true;

    constructor(private orcamentoService: OrcamentoService,
        public alertService: AlertService, public usuarioService: UsuarioService,
        public modalCtrl: ModalController, public navParams: NavParams,
        public gestaoPcaService: GestaoPcaService, public menuService: MenuService) {

        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

        this.carregarDados();

        this.setModuloId(12);
    }

    carregarDados() {
        if (!this.isJurisdicionado) {
            this.orcamentoService.obterListaAnalises(this.orcamentoService.codigoModuloOrcamento).subscribe(data => {
                this.listaAnalises = data;

                this.listaAnalises.forEach(x => {
                    if (x.idStatusAnalise == 5 || x.idStatusAnalise == 6 || x.idStatusAnalise == 7) {
                      x.idStatusAnalise = 11;
                      x.dsStatusAnalise = 'Para Consulta';
                    }
                  });

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            });
        } else {
            this.orcamentoService.obterListaAnalisesJur(this.orcamentoService.codigoModuloOrcamento).subscribe(data => {
                this.listaAnalises = data;

                this.loading = false;
            }, error => {
                console.log("erro: " + error);
                this.loading = false;
            });
        }
    }

    redirecionarParaAnalise(analise) {

        analise.cdModulo = this.orcamentoService.obterIdPaginaOrcamento();
        this.menuService.redirecionarSubPagina(this.orcamentoService.obterIdPaginaOrcamento(), analise);
    }

    voltarPCA() {
        let idSecaoPaginaGestaoPCA = '964';

        this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
    }

    previsualizarCertificado() {

        let modal = this.modalCtrl.create(ModalPreVisualizarOrcamentoPage, {});
        modal.onDidDismiss(retornoModal => {
            //retorno da modal
        });
        modal.present();
    }

    naoSeAplica(item) {

        this.gestaoPcaService.obterModuloPcaPorPCAPorModulo(this.gestaoPcaService.getPCA().id, 12).subscribe(data => {

            let titulo = "NÃO SE APLICA";
            let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
                {
                    titulo: titulo,
                    moduloPca: data,
                    IdProcesso: data.moduloPca,
                    tipoAnalise: 0,
                    jurisdicionado: this.isJurisdicionado,
                    isCGE: this.isCGE,
                    origemArquivo: "NA",
                    origemFilter: 'ORCAMENTO',
                    tipoEntidadeExercicio: 0,
                    tipoDocumento: 0
                });
            modal.onDidDismiss(retornoModal => {
                this.carregarDados();
                if (retornoModal && retornoModal.flag) {
                }
            });

            modal.present();

        }, error => {
            console.log("erro ao carregar modulo pca: " + error);
        });

    }

    naoSeAplicaAnalise(item) {

        this.gestaoPcaService.obterModuloAnalise(item.idModuloAnalise).subscribe(data => {

            let titulo = "NÃO SE APLICA";
            let modal = this.modalCtrl.create(ModalNaoSeAplicaPage,
                {
                    titulo: titulo,
                    moduloAnalise: data,
                    IdProcesso: data.moduloAnalise,
                    tipoAnalise: 0,
                    jurisdicionado: this.isJurisdicionado,
                    isCGE: this.isCGE,
                    origemArquivo: "NA",
                    origemFilter: 'ORCAMENTO',
                    tipoEntidadeExercicio: 0,
                    tipoDocumento: 0
                });
            modal.onDidDismiss(retornoModal => {
                this.carregarDados();
                if (retornoModal && retornoModal.flag) {
                }
            });

            modal.present();

        }, error => {
            console.log("erro ao carregar modulo pca: " + error);
        });

    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/orcamento/resumo-acoes/resumo-acoes.ts